import React, { useState, useEffect, useRef } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
import Header from "../../../Components/Header/Header";
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import Export from "../../../assets/images/export.svg";
import View from "../../../assets/images/view.svg";
import Edit from "../../../assets/images/edit.png";
import { Button, ProgressBar } from 'react-bootstrap';

import Cargoplane from "../../../assets/images/plane.svg";
import Cuser from "../../../assets/images/cuser.png";
import Cargotruck from "../../../assets/images/cargo-truck.png";
import { Link } from 'react-router-dom';
import ActivityComments from '../../../Components/common/ActivityComments';
import ImageUpload from '../../../Components/common/ImageUpload';
import { GETULDDETAILS, MVTHDETAILS } from '../../../Utils/conts';
import { withRFSToken } from '../../../Services/axios';
import Accordion from 'react-bootstrap/Accordion';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { applyOffsetToDateTime, CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions';
import Rapdf from "../../../assets/images/pdf.png";


const PTDetails = ({ onBack, onDBack, PtClick }) => {
    const isMounted = useRef(false);
    const [operationDate, setOperationDate] = useState('');
    const [operationTime, setOperationTime] = useState('');
    const [sourceType, setSourceType] = useState(''); // To track which page we came from

    const [gridData, setGridData] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const gridRef = useRef(null);
    const storedData = JSON.parse(localStorage.getItem('Fdetails'));
    const id = storedData?.id;
    const F_AddULD = localStorage.getItem('F_AddULD');
    const [filterApplied, setFilterApplied] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const loadDetails = (uldNumber) => {

        let endpoint = '';
        let payload = {};

        if (storedData.source === 'buildup') {
            endpoint = 'uld-control/build-up-details';
            payload = { uld_id: uldNumber };
        } else if (storedData.source === 'activeTrips') {
            endpoint = 'forwarder-uld-control/receipt-details';
            payload = { receipt_id: uldNumber };
        } else if (storedData.source === 'uldStock') {
            { console.log("inside here") }
            endpoint = 'forwarder-uld-control/get-uld-details';
            payload = { uld_id: uldNumber };
        }

        // setDisLoading(true);
        CallApi({
            endPoint: endpoint,
            payload: payload,
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    setSelectedRowData(innerData);
                }
            },
            // onError: (msg) => toast.error(msg)
        });
    }

    useEffect(() => {
        if (isMounted.current) return;
        // const source = localStorage.getItem('Fdetails');
        setSourceType(storedData.source || 'active_trips');
        if (storedData) {
            loadDetails(storedData.id);
        }
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []); // Second useEffect that depends on sourceType

    // const history = useHistory();
    // const location = useLocation();

    // if (Uldid){
    //     setUldNumber(Uldid);
    //     queryParameters.delete('uld_number');
    //     history.push({
    //         pathname: location.pathname,
    //       });
    //     window.location.replace('/ULDControl/MovementHistory')
    // }
    const [uldNumber, setUldNumber] = useState();



    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            const source = {

                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'uld_number', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'airline_master', type: 'string' },
                    { name: 'condition_code', type: 'string' }
                ],
                localdata: selectedRowData?.uld_informations
                // pagesize: 50, 
                // filter: function (allfilters) {
                //     if (allfilters.length > 0) {
                //         setFilterApplied(true);
                //         filterForCheck = true;
                //     } else {
                //         setFilterApplied(false);
                //         filterForCheck = false;
                //     }
                //     window.$(gridRef.current).jqxGrid('clearselection');
                //     window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                // },
                // beforeprocessing: function (data) {
                //     source.totalrecords = data.TotalRows;
                // },
                // sort: function (column, direction) {
                //     window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                // },
                // root: "Rows",
                // cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);

            const columns = [

                { text: 'ULD Number', datafield: 'uld_number', width: '12%' },
                { text: 'Type Code', datafield: 'type_code', width: '10%' },
                { text: 'Serial No.', datafield: 'serial_number', width: '12%' },
                { text: 'Owner Code', datafield: 'owner_code', width: '10%' },
                {
                    text: 'Airline Name', datafield: 'airline_master', width: '16%',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, cellValue, rowdata) {
                        if (value.airline_name == null) {
                            return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;"> </div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align"  style="line-height: 38px;">' + value.airline_name + '</div>';
                        }
                    }
                },
                { text: 'Condition Code', datafield: 'condition_code', width: '12%' }
            ];

            // Define nested grid columns for buildup
            const nestedColumns = [
                { text: 'House Awb', datafield: 'house_awb', width: '8%' },
                { text: 'Pcs', datafield: 'pieces', width: '8%' },
                { text: 'Weight', datafield: 'weight', width: '8%' },
            ];

            // Initialize nested grid if sourceType is buildup
            const initrowdetails = (index, parentElement, gridElement, record) => {
                if (sourceType !== 'buildup') return;

                const nestedGridContainer = parentElement.children[0];
                const id = record.uid.toString();

                const nestedSource = {
                    datatype: 'json',
                    datafields: [
                        { name: 'id', type: 'string' },
                        { name: 'house_awb', type: 'string' },
                        { name: 'pieces', type: 'string' },
                        { name: 'weight', type: 'string' },
                    ],
                    url: `${process.env.REACT_APP_RFS_URL}uld-control/sub-sub-build-up?id=${record.id}`,
                    // beforeSend: function (jqXHR) {
                    //     jqXHR.setRequestHeader('Authorization', token);
                    // },
                    root: "Rows",
                    cache: false
                };

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    autoheight: false,
                    height: (6 * 45),
                    selectionmode: '',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowsheight: 45,
                    showemptyrow: false
                };

                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // Add nested grid support only for buildup
                rowdetails: sourceType === 'buildup',
                initrowdetails: sourceType === 'buildup' ? initrowdetails : null,
                rowdetailstemplate: sourceType === 'buildup' ? {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (6 * 45),
                    rowdetailshidden: true
                } : null,
                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };

            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.awb_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.awb_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.awb_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.awb_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
            });
            window.$(gridRef.current).on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                }
            });
        }
    }, [gridData, sourceType, selectedRowData]);




    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const pageBack = () => {
        if (storedData.tab) {
            const localData = { id: storedData.backId, source: 'uldStock' }
            localStorage.setItem('Fdetails', JSON.stringify(localData));
            onDBack();
        } else {
            onBack()
        }
    }

    const editUld = () => {
        const filteredGridSelect = selectedRowData?.uld_informations?.map(
            ({ uld_number, type_code, owner_code, serial_number, condition_code, id, assigned, handlerOrgId }) => ({
                uld_number,
                type_code,
                owner_code,
                serial_number,
                condition_code,
                uld_id: id,
                assigned,
                handlerOrgId
            })
        );
        const lData = {
            station_name: selectedRowData?.handler_station?.code,
            handler_id: selectedRowData.handler_org_id,
            control_receipt_numb: selectedRowData.control_receipt_numb,
            door: selectedRowData.door,
            planned_slot: selectedRowData.planned_slot,
            planned_transfer_date: selectedRowData.planned_transfer_date,
            trip_id: selectedRowData.id,
            acn_id: selectedRowData.acin_id,
            trucking_company: selectedRowData.drivername,
            driver_name: selectedRowData?.drivername,
            vehicle_id: selectedRowData?.vehicle?.truck_Registration_Number,
            warehouse_id: selectedRowData?.warehouse_id,
            trailer_id: selectedRowData?.trailer_nr,
            remarks: selectedRowData?.remarks,
            slot: selectedRowData?.slots.length ? selectedRowData?.slots[0] : null,
            files: selectedRowData?.attachments,
            booking_slot_datetime: `${selectedRowData?.planned_transfer_date}T${selectedRowData?.planned_time}`,
            ulds: filteredGridSelect
        };
        localStorage.setItem('plan_trip', JSON.stringify(lData));
        PtClick()
    }

    return (
        <>

            {/* <div className="">
                <Header />
                <div className="schedule">
                    <LeftMenu /> */}
            <div className='main-panel'>
                {/* <Link to={storedData?.backUrl} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link> */}
                <Link to='#' onClick={pageBack} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                <div className='maindiv'>
                    <div className='SecondDiv mt-3'>
                        {/* <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button> */}
                        <div className='girddtals_header'>
                            <h3>
                                {sourceType === 'buildup' && selectedRowData?.uld_det_id}
                                {sourceType === 'activeTrips' && selectedRowData?.control_receipt_numb}
                                {sourceType === 'uldStock' && selectedRowData?.uld_number}
                                &nbsp;
                                <span className='position-relative'>
                                    {/* {
                                                selectedRowData?.pick_status && Array.isArray(selectedRowData?.pick_status) ?
                                                    selectedRowData?.pick_status.map((item) =>
                                                        <>
                                                            <div class={`mt-0 ${item.color_status}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{item.status || ''}</div>
                                                        </>
                                                    )
                                                    : ''
                                            } */}
                                    {sourceType === 'buildup' &&
                                        <div className={`mt-0 ${selectedRowData?.buildup_status == 'Finalized' ? 'fw_complet'
                                            : selectedRowData?.buildup_status == 'In Progress' ? 'fw_progess'
                                                : ''}`} style={{ position: 'absolute', top: '1px', left: '0' }}>
                                            {selectedRowData?.buildup_status || ''}
                                        </div>
                                    }
                                    {sourceType === 'activeTrips' &&
                                        <div className={`mt-0 ${selectedRowData?.trip_status == 'Completed' ? 'fw_complet'
                                            : selectedRowData?.trip_status == 'Planned' ? 'fw_planed'
                                                : selectedRowData?.trip_status == 'Active' ? 'fw_progess'
                                                    : ''}`} style={{ position: 'absolute', top: '1px', left: '0' }}>
                                            {selectedRowData?.trip_status || ''}
                                        </div>
                                    }
                                    {sourceType === 'uldStock' &&
                                        <div className={`mt-0 ${selectedRowData?.status_name == 'On Stock' ? 'fw_progess' : 'fw_planed'}`} style={{ position: 'absolute', top: '1px', left: '0' }}>{selectedRowData?.status_name || ''}</div>
                                    }
                                </span>
                                {/* <Link style={{position: 'absolute', right: '0'}} to='#' onClick={editUld}><img src={Edit} /></Link> */}
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}

                            </div>

                        </div>

                        <div className='update_info'>
                            <div className='d-flex justify-content-between align-items-center MB-2'>
                                <h4>Trip Details</h4>
                            </div>
                            <ul>
                                <li>
                                    <span>Date In :</span>
                                    {/* <span>{selectedRowData?.createDate?.slice(0, 10) + ' ' + selectedRowData?.createDate?.slice(11, 16)}</span> */}
                                    <span>{applyOffsetToDateTime(selectedRowData?.createDate, 'H')}</span>
                                </li>
                                <li>
                                    <span>Date Out :</span>
                                    <span>{applyOffsetToDateTime(selectedRowData?.archiveDate, 'H')}</span>
                                </li>
                                <li>
                                    <span>Receipt :</span>
                                    <span><a href={selectedRowData?.receipt_pdf} target='_blank'><img src={Rapdf} alt="Link" style={{ width: '25px' }} /></a></span>
                                </li>
                            </ul>
                        </div>
                        {/* <div className='movment_list'>
                                    <ul>
                                       
                                    </ul>
                                </div> */}
                        <ImageUpload
                            ref={imageUploadRef}
                            attachable_type={'forwarder_plan_trip'}
                            attachable_id={selectedRowData?.id}
                            attachments={selectedRowData?.attachments}
                            onDeleteSuccess={() => loadDetails(selectedRowData?.id)}
                        />
                        <ActivityComments
                            commentable_type={'forwarder_plan_trip'}
                            commentable_id={selectedRowData?.id}
                            allactivities={selectedRowData?.activities}
                            onReloadDetails={loadDetails}
                        />
                    </div>
                    <div className='trashdonload mt-3'>
                        {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                    </div>

                </div>

            </div>
            {/* </div>
            </div> */}
        </>
    )
}

export default PTDetails